import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';

interface RequirePermissionProps {
  permission: string;
}

const RequirePermission: React.FC<RequirePermissionProps> = ({ permission }) => {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress size={60} thickness={4} />
      </Box>
    );
  }

  // Admin zawsze ma dostęp (sprawdzamy z uwzględnieniem wielkości liter)
  if (user?.role && String(user.role).toLowerCase() === 'admin') {
    return <Outlet />;
  }

  // Jeśli brak mapy uprawnień lub jest pusta, traktuj jako dostępny (zachowanie wstecznej kompatybilności)
  if (!user?.permissions || Object.keys(user.permissions).length === 0) {
    return <Outlet />;
  }

  // Fallback: jeżeli prosimy o "invoices", a klucza brak — traktuj jako dozwolone
  const allowed = permission === 'invoices' && !(permission in user.permissions)
    ? true
    : !!user.permissions[permission as keyof typeof user.permissions];
  if (!allowed) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

export default RequirePermission;


